"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var jdStoreApi = _interopRequireWildcard(require("@/api/jdStoreApi"));
var _validate = require("@/utils/validate");
var _PriceAdjustDialog = _interopRequireDefault(require("./components/PriceAdjustDialog.vue"));
var _PriceRecordDialog = _interopRequireDefault(require("./components/PriceRecordDialog.vue"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
var cache;
function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var r, c, a = Object.defineProperty, n = { __proto__: null, default: e }; if (Object(e) !== e) return n; if (cache || "function" != typeof WeakMap || (cache = new WeakMap()), cache) { if (cache.has(e)) return cache.get(e); cache.set(e, n); } for (c in e) "default" !== c && {}.hasOwnProperty.call(e, c) && ((r = a && Object.getOwnPropertyDescriptor(e, c)) && (r.get || r.set) ? a(n, c, r) : n[c] = e[c]); return n; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'JdSrot',
  components: {
    PriceAdjustDialog: _PriceAdjustDialog.default,
    PriceRecordDialog: _PriceRecordDialog.default
  },
  data: function data() {
    return {
      listPram: {
        parentId: '',
        categoryId: '',
        groupName: '',
        groupLevel: '',
        status: ''
      },
      treeList: [],
      listLoading: false,
      syncLoading: false
    };
  },
  mounted: function mounted() {
    this.handlerGetListData();
  },
  methods: {
    formatLevel: function formatLevel(groupLevel) {
      if (groupLevel === undefined || groupLevel === null) return '--';
      var s = String(groupLevel);
      if (s === '1') return '一级';
      if (s === '2') return '二级';
      if (s === '3') return '三级';
      return s;
    },
    getRequestBody: function getRequestBody() {
      var _this$listPram = this.listPram,
        parentId = _this$listPram.parentId,
        categoryId = _this$listPram.categoryId,
        groupName = _this$listPram.groupName,
        groupLevel = _this$listPram.groupLevel,
        status = _this$listPram.status;
      return {
        parentId: parentId || undefined,
        categoryId: categoryId || undefined,
        groupName: groupName || undefined,
        groupLevel: groupLevel || undefined,
        status: status === '' ? undefined : Number(status)
      };
    },
    handerSearch: (0, _validate.Debounce)(function () {
      this.handlerGetListData();
    }, 300),
    handleSyncAll: function handleSyncAll() {
      var _this = this;
      this.syncLoading = true;
      this.$message.warning('数据同步中请耐心等待');
      jdStoreApi.syncJdCategoryAll().then(function (res) {
        if (res == '同步成功') {
          _this.$message.success('数据同步成功');
        } else {
          _this.$message.error('数据同步失败');
        }
        _this.handlerGetListData();
      }).catch(function () {
        _this.$message.error('同步失败');
      }).finally(function () {
        _this.syncLoading = false;
      });
    },
    handleReset: function handleReset() {
      var _this2 = this;
      this.listPram = {
        parentId: '',
        categoryId: '',
        groupName: '',
        groupLevel: '',
        status: ''
      };
      this.$nextTick(function () {
        _this2.handlerGetListData();
      });
    },
    handlerGetListData: function handlerGetListData() {
      var _this3 = this;
      this.listLoading = true;
      var body = this.getRequestBody();
      jdStoreApi.getJdCategoryList(body).then(function (res) {
        _this3.treeList = res;
      }).catch(function () {
        _this3.treeList = [];
      }).finally(function () {
        _this3.listLoading = false;
      });
    },
    handleStatusChange: function handleStatusChange(row, val) {
      var _this4 = this;
      var categoryId = row && row.categoryId;
      var newStatus = val;
      var oldStatus = newStatus === 1 ? 0 : 1;
      if (categoryId === undefined || categoryId === null || categoryId === '') {
        this.$message.error('缺少categoryId');
        this.$set(row, 'status', oldStatus);
        return;
      }
      jdStoreApi.updateJdCategoryStatus({
        categoryId: categoryId,
        status: newStatus
      }).then(function (res) {
        if (res == '状态更新成功') {
          _this4.$message.success('操作成功');
          _this4.handlerGetListData();
          return;
        }
        _this4.$set(row, 'status', oldStatus);
        _this4.$message.error(res && res.message || '操作失败');
      }).catch(function () {
        _this4.$set(row, 'status', oldStatus);
        _this4.$message.error('操作失败');
      });
    },
    handlePriceAdjust: function handlePriceAdjust(row) {
      this.$refs.priceAdjustDialog.open(row);
    },
    handlePriceRecord: function handlePriceRecord(row) {
      this.$refs.priceRecordDialog.open(row);
    }
  }
};